"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HighlightedEventCard = HighlightedEventCard;
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _useMediaQuery2 = _interopRequireDefault(require("@mui/material/useMediaQuery"));
var _styles = require("@mui/material/styles");
var _moment = _interopRequireDefault(require("moment"));
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _highlightedEventCardBottomIllus = _interopRequireDefault(require("../assets/images/highlighted-event-card-bottom-illus.svg"));
var _highlightedEventCardTopIllus = _interopRequireDefault(require("../assets/images/highlighted-event-card-top-illus.svg"));
var _trophy = _interopRequireDefault(require("../assets/images/trophy.svg"));
var _hooks = require("../hooks");
var _services = require("../services");
var _button = require("./button");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const now = (0, _moment.default)();
function HighlightedEventCard(_ref) {
  let {
    Button: _Button,
    hasGeogroups,
    geogroup,
    highlightedEvent,
    highlightedEventChallenge,
    displayButtonProps,
    onJoined,
    onClose
  } = _ref;
  const [joiningEvent, setJoiningEvent] = (0, _react.useState)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  const theme = (0, _styles.useTheme)();
  const smallDevice = (0, _useMediaQuery2.default)(theme.breakpoints.down('md'));
  const {
    cancellablePromise,
    cancelPromises
  } = (0, _hooks.useCancellablePromise)();
  (0, _react.useEffect)(() => {
    return () => cancelPromises();
  }, []);
  async function handleEventJoin() {
    if (!geogroup || !highlightedEvent) return;
    setJoiningEvent(true);
    try {
      const challenge = await cancellablePromise(_services.GeogroupService.addChallenge({
        geoGroupId: geogroup.id
      }, {
        event: highlightedEvent.id
      }));
      await cancellablePromise(_services.UserService.joinChallenge({
        geogroupId: geogroup.id,
        challengeId: challenge.id
      }));
      enqueueSnackbar(t('commons.highlighted_event_card.success'));
      onJoined?.(challenge);
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        enqueueSnackbar(t('commons.highlighted_event_card.server_error'), {
          variant: 'error'
        });
        setJoiningEvent(false);
      }
    }
  }
  if (!highlightedEvent || highlightedEvent.endDate.isBefore(now) || highlightedEventChallenge === undefined) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  const Button = _Button || _button.Button;
  const row = !smallDevice;
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: "#ffe27d",
    borderRadius: 2,
    overflow: "hidden",
    position: "relative",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    left: 0,
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: 1
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _highlightedEventCardTopIllus.default
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bottom: 0,
    display: "flex",
    justifyContent: "flex-end",
    left: 0,
    position: "absolute",
    right: 0,
    zIndex: 1
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _highlightedEventCardBottomIllus.default
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: row ? 'center' : 'flex-start',
    display: "flex",
    gap: 2,
    padding: 2,
    position: "relative",
    zIndex: 2
  }, highlightedEvent.challengeTemplate?.icon ? /*#__PURE__*/_react.default.createElement("img", {
    src: highlightedEvent.challengeTemplate.icon,
    style: {
      flexShrink: 0
    },
    width: 100
  }) : /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    bgcolor: "#fff",
    borderRadius: 2,
    display: "flex",
    flexShrink: 0,
    height: 50,
    justifyContent: "center",
    width: 100
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _trophy.default,
    width: 50
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: row ? 'center' : 'flex-start',
    display: "flex",
    flexDirection: row ? 'row' : 'column',
    flexGrow: 1,
    gap: row ? 2 : 1
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 700
  }, geogroup !== null && highlightedEventChallenge ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: '#048760'
    }
  }, "\u2713"), ' ', t('commons.highlighted_event_card.title_joined', {
    title: highlightedEvent.title
  })) : t('commons.highlighted_event_card.title_not_joined', {
    title: highlightedEvent.title
  })), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, geogroup === null && hasGeogroups ? t('commons.highlighted_event_card.event_indications_description') : t('commons.highlighted_event_card.description'))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexShrink: 0,
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    href: "https://challenge-maiavelo.geovelo.fr/",
    rel: "noreferrer",
    size: "medium",
    target: "_blank",
    variant: geogroup === null && !hasGeogroups ? 'contained' : 'text'
  }, geogroup === null && !hasGeogroups ? t('commons.highlighted_event_card.actions.join') : t('commons.actions.learn_more')), geogroup && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, highlightedEventChallenge ? /*#__PURE__*/_react.default.createElement(Button, _extends({
    disableElevation: true,
    color: "primary",
    size: "medium",
    variant: "contained"
  }, displayButtonProps), t('commons.highlighted_event_card.actions.display')) : /*#__PURE__*/_react.default.createElement(Button, {
    disableElevation: true,
    color: "primary",
    disabled: joiningEvent,
    onClick: handleEventJoin,
    size: "medium",
    variant: "contained"
  }, t('commons.highlighted_event_card.actions.join'))))), onClose && /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    title: t('commons.actions.close')
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    onClick: onClose,
    size: "small",
    style: {
      alignSelf: 'flex-start',
      flexShrink: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_Close2.default, {
    fontSize: "small"
  })))));
}